import { useState } from 'react';

import { AlertDialog, Box, Button } from 'design-library';

import { UserRole } from 'common/types';

import { UserManagementServices } from 'admin/services';

import { UserActionOptions } from './type';

export const UserActions = ({
  userId,
  isUserActive,
  role,
  onClickProfileView = () => ({}),
}: {
  userId: string;
  isUserActive: boolean;
  role: UserRole;
  onClickProfileView?: () => void;
}) => {
  const [action, setAction] = useState<UserActionOptions | null>(null);

  const activateOrDeactivateUser = async (
    option: UserActionOptions,
    userId: string
  ) => {
    if (option === 'activate') {
      await UserManagementServices.activateUser({ role, userId });
    } else if (option === 'deactivate') {
      await UserManagementServices.deactivateUser({ role, userId });
    }
    window.location.reload();
  };

  return (
    <Box styles={{ alignContent: 'center', justifyContent: 'center' }}>
      {role === 'expert' && (
        <Button size="small" onClick={onClickProfileView}>
          View
        </Button>
      )}
      {!isUserActive ? (
        <Button
          size="small"
          color="error"
          variant="outlined"
          onClick={() => setAction('deactivate')}
        >
          Deactivate
        </Button>
      ) : (
        <Button
          size="small"
          color="success"
          onClick={() => setAction('activate')}
        >
          Activate
        </Button>
      )}
      {action && (
        <AlertDialog
          open={Boolean(action)}
          title={`${action === 'activate' ? 'Activate' : 'Deactivate'} ${
            role === 'expert' ? 'Expert' : 'Hirer'
          }`}
          onClose={() => setAction(null)}
          onConfirm={() => {
            activateOrDeactivateUser(action, userId).finally(() =>
              setAction(null)
            );
          }}
        />
      )}
    </Box>
  );
};
